import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import aboutImg1 from "../assets/11.jpg"; // Section 1 image
import aboutImg2 from "../assets/12.jpg"; // Section 2 image
import valueImg from "../assets/img1.jpg"; // Our Value image
import bgImage from "../assets/13.jpg"; // Top heading background
import coreImage from "../assets/scr.jpeg";
import quickservice from "../assets/quickservice.png";
import research from "../assets/research.png";
import techqty from "../assets/techqty.png";
import timili from "../assets/timili.png";
import maorgov from "../assets/maorgov.png";

const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 space-y-20">
      {/* Top Heading with background */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative w-full h-[240px] flex flex-col justify-center px-6"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-left text-white max-w-2xl">
          <h1 className="text-4xl font-bold">About Us</h1>
          <p className="mt-2">
            <Link to="/" className="underline hover:text-green-400">Home</Link> / About Us
          </p>
        </div>
      </motion.div>

      {/* Section 1 - Company Intro */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <motion.img
          src={aboutImg1}
          alt="About"
          className="w-full h-[450px] object-cover rounded-2xl shadow-lg"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-gray-800"
        >
          <h2 className="text-2xl font-semibold mb-4">
            WVT Elevators Private Limited
          </h2>
          <p className="leading-relaxed">
            Over the years, the company has grown under the guidance of both the
            Directors of the firm who have 30 years of technical experience and
            25 years of marketing experience respectively share their
            entrepreneurial spirit, commitment to highest standards of integrity
            and ability to inspire people to action.
            <br /><br />
            Since our incorporation in the year 2014, we have emerged as one of
            the competitive organization indulged in providing high performing
            Lifts (Elevators) for Residential, Commercial, Hospitals, Shopping
            Complex Malls, Automobiles and Industrial Goods Lifts.
            <br /><br />
            Our Clientele include leading Private, Government Client Northern
            Railway, PWD Delhi, MES and Semi government sector spread all over
            India.
          </p>
        </motion.div>
      </div>

      {/* Section 2 - Infrastructure & Team */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-gray-800"
        >
          <h2 className="text-2xl font-semibold mb-4">Infrastructure & Team</h2>
          <p className="leading-relaxed">
            We have a state of the art engineering infrastructure, which allows
            us to dream and create new mobility solutions for our customers
            according to their needs. Our design facilities are aimed at
            providing technological solutions to stay ahead in competition and
            make the latest technology available to our customers.
            <br /><br />
            Our stringent quality control process helps us to keep our product
            quality best in the market. The raw materials we source are of the
            best quality and accepted only after passing Indian standard quality
            tests and international standard quality tests.
          </p>
        </motion.div>
        <motion.img
          src={aboutImg2}
          alt="Team"
          className="w-full h-[450px] object-cover rounded-2xl shadow-lg"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
      </div>

      {/* Section 3 - Vision & Mission */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white p-8 rounded-2xl shadow-md text-left"
      >
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our Vision & Mission</h2>
        <p className="leading-relaxed max-w-3xl">
          <strong>Our Vision:</strong> To be the recognized leader in service
          excellence that offers great value to customers through its innovative
          and advanced product range.
          <br /><br />
          <strong>Our Mission:</strong> To create unique and comfortable
          elevator experiences for our users through continuous research and
          development and by offering a great value to our customers.
        </p>
      </motion.div>

      {/* Section 4 - Our Value */}
      <div className="my-20">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold text-center text-gray-900 mb-10"
        >
          Our Value
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-gray-800 flex flex-col justify-center"
          >
            <p className="leading-relaxed text-gray-600 text-justify">
              <strong>Comfort:</strong> We wish to design and build products that offer great comfort to our users.
              <br /><br />
              <strong>Safety & Reliability:</strong> Safety and reliability are the core factors of vertical transportation. We continuously improve safety features and develop safer technologies for upcoming products.
              <br /><br />
              <strong>Excellence:</strong> We aim to achieve benchmarks for superior service in every project, product, and service. We also provide the best after-sale services and maintenance.
            </p>
          </motion.div>
          <motion.img
            src={valueImg}
            alt="Our Value"
            className="w-full h-[450px] object-cover rounded-2xl shadow-lg"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          />
        </div>
      </div>

      {/* Section 5 - Core Values */}
      <div className="my-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <motion.img
            src={coreImage}
            alt="Quality"
            className="w-full h-[450px] object-cover rounded-2xl shadow-lg"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          />
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-gray-800 flex flex-col justify-center"
          >
            <p className="leading-relaxed text-gray-600 text-justify">
              <strong>Quality:</strong> Elevators are complex systems, and quality is crucial for reliability, efficiency, and long-term performance. WVT strive for excellence in design, engineering, and manufacturing.
              <br /><br />
              <strong>Customer Satisfaction:</strong> Customer satisfaction is a key driver in the WVT. WVT Elevator aim to provide innovative products and prompt, effective services that meet and exceed customer expectations.
              <br /><br />
              <strong>Innovation:</strong> The industry is constantly evolving, and elevator companies are encouraged to push boundaries with new technologies and designs to improve efficiency, safety, and user experience.
              <br /><br />
              <strong>Integrity:</strong> Upholding the highest ethical standards and building strong, transparent relationships with clients is essential for trust and long-term success.
              <br /><br />
              <strong>Adaptability:</strong> Each building and its needs are unique. WVT Elevator need to be adaptable and provide customized solutions to meet specific requirements.
              <br /><br />
              <strong>Energy Efficiency:</strong> WVT Elevators consume a significant amount of energy. WVT are focused on developing and implementing energy-efficient technologies to reduce environmental impact and lower operating costs for building owners.
            </p>
          </motion.div>
        </div>
      </div>






{/* Our Groths Create  */}
{/* Our Growth Section - Text Only Timeline */}
<motion.div
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  className="w-full py-32 relative bg-gray-50"
>
  <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-20">
    Our Growth
  </h2>

  <div className="relative w-full max-w-4xl mx-auto">
    {/* Center vertical line */}
    <div className="absolute left-1/2 top-0 w-1 bg-blue-400 h-full -translate-x-1/2"></div>

    {/* Timeline events */}
    {[
      { year: "2014", title: "Company Founded", desc: "Incorporated under the guidance of our Directors." },
      { year: "2016", title: "First Major Installation", desc: "Completed large-scale residential & commercial projects." },
      { year: "2018", title: "Expansion", desc: "Expanded operations to Northern India, serving government clients." },
      { year: "2020", title: "Technology Upgrade", desc: "Integrated German technology for higher quality standards." },
      { year: "2023", title: "Industry Leader", desc: "Recognized for innovative solutions & prompt service." },
    ].map((event, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
        className={`mb-12 w-full flex flex-col md:flex-row items-start relative ${
          index % 2 === 0 ? "md:justify-start md:pl-12" : "md:justify-end md:pr-12 text-right"
        }`}
      >
        {/* Dot */}
        <div className="absolute left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-blue-500 border-2 border-white z-10"></div>

        {/* Text */}
        <div className="md:w-5/12 text-gray-800">
          <p className="font-bold text-blue-600">{event.year}</p>
          <p className="font-semibold">{event.title}</p>
          <ul className="list-disc list-inside mt-2 text-gray-600">
            <li>{event.desc}</li>
          </ul>
        </div>
      </motion.div>
    ))}
  </div>
</motion.div>



      {/* Why Choose Us Section */}
      <div className="my-32 px-6">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold text-gray-900 text-center mb-16"
        >
          Why Choose Us?
        </motion.h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 max-w-7xl mx-auto">
          {/* Feature 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5, delay: 0.05 }}
            className="flex flex-col items-center text-center space-y-3 cursor-pointer"
          >
            <img src={research} alt="Research & Development" className="w-16 h-16" />
            <h3 className="font-semibold text-lg">Research & Development</h3>
            <p className="text-gray-600 text-sm">
              Innovation driven by continuous research and development.
            </p>
          </motion.div>

          {/* Feature 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="flex flex-col items-center text-center space-y-3 cursor-pointer"
          >
            <img src={techqty} alt="Quality Assurance" className="w-16 h-16" />
            <h3 className="font-semibold text-lg">Highest Quality Standards</h3>
            <p className="text-gray-600 text-sm">German Technology</p>
          </motion.div>

          {/* Feature 3 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="flex flex-col items-center text-center space-y-3 cursor-pointer"
          >
            <img src={maorgov} alt="Government Projects" className="w-16 h-16" />
            <h3 className="font-semibold text-lg">Major Projects</h3>
            <p className="text-gray-600 text-sm">
              Part of Government Projects, Hospitals, Hotels & Residential Apartments
            </p>
          </motion.div>

          {/* Feature 4 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col items-center text-center space-y-3 cursor-pointer"
          >
            <img src={timili} alt="Timely Delivery" className="w-16 h-16" />
            <h3 className="font-semibold text-lg">Timely Delivery</h3>
            <p className="text-gray-600 text-sm">Installation on time with quick service</p>
          </motion.div>

          {/* Feature 5 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            className="flex flex-col items-center text-center space-y-3 cursor-pointer"
          >
            <img src={quickservice} alt="Quick Service" className="w-16 h-16" />
            <h3 className="font-semibold text-lg">Quick Service</h3>
            <p className="text-gray-600 text-sm">Prompt service and customer support</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
